import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import LoginPage from './LoginPage';
import PerformRouter from './nav/Router';
import PerformAdminRouter from './nav/AdminRouter';
import PerformBuilders from './nav/Builders';
import Policy from './nav/Policy';
import UserLogout from './user/UserLogout';
import 'global/utils/support';
import { getAlerts } from 'redux/actions/view';
import isLoggedIn from 'global/utils/isLoggedIn';
import AppThemeProvider from 'global/components/app-theme-provider';
import { get, size } from 'global/lib/lodash';
import { getUserPermissions, getAccountSettings } from 'redux/actions/userLogin';
import SelfRegister from './user/SelfRegister';
import { registerTimer } from 'global/utils/activityTimer';
import { useUser } from 'global/hooks/useUser';
import { isDark } from 'global/styles';
import { LoadAccountSettings } from './LoadAccontSettings';

registerTimer();

if (!Array.prototype.at) {
  function at(n) {
    // ToInteger() abstract op
    n = Math.trunc(n) || 0;
    // Allow negative indexing from the end
    if (n < 0) n += this.length;
    // OOB access is guaranteed to return undefined
    if (n < 0 || n >= this.length) return undefined;
    // Otherwise, this is just normal property access
    return this[n];
  }

  const TypedArray = Reflect.getPrototypeOf(Int8Array);
  for (const C of [Array, String, TypedArray]) {
    Object.defineProperty(C.prototype, 'at', { value: at, writable: true, enumerable: false, configurable: true });
  }
}

const useStyles = makeStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em',
      height: '0.1em',
    },
    '*::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(10,10,10,0.10)',
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.2)',
      outline: '1px solid slategrey',
    },
    html: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,

      '& a': {
        color: isDark(theme) ? theme.colors.white : undefined,
      },
    },
  },
}));

const AppWithRouter = withRouter((props) => {
  useStyles();
  const [title, changeTitle] = useState(<div>Perform</div>);
  const loggedIn = useSelector((state) => isLoggedIn(state.auth));
  const { me } = useUser();

  const dispatch = useDispatch();

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      const scripta = document.createElement('script');
      scripta.async = true;
      scripta.src = 'https://www.googletagmanager.com/gtag/js?id=G-KQGEE7JKYT';

      const scriptb = document.createElement('script');
      scriptb.async = true;
      scriptb.text = "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}window.gtag = gtag;gtag('js', new Date());gtag('config', 'G-KQGEE7JKYT');";

      document.head.appendChild(scripta);
      document.head.appendChild(scriptb);
    }
  }, []);

  useEffect(() => {
    if (props.location && process.env.NODE_ENV === 'production') {
      window.gtag('config', 'G-KQGEE7JKYT', {
        page_title: props.location.pathname,
        page_path: props.location.pathname,
      });
    }
  }, [props.location]);

  useEffect(() => {
    if (loggedIn) {
      dispatch(getAlerts());
      dispatch(getUserPermissions());
      if (process.env.NODE_ENV === 'production') {
        window.gtag('set', 'userId', get(me, 'id'));
        window.gtag('set', 'user_properties', {
          user_realm_id: get(me, 'realm.id'),
        });
        window.gtag('event', 'login', {
          event_category: 'engagement',
          event_label: 'login',
        });
      }
    } else {
      // if user sets a path in the url when they are not currently logged in, it redirects them to login
      const pathname = window.location.pathname;
      if (size(pathname) > 1 && pathname.indexOf('/register/') === -1 && pathname.indexOf('/policy') === -1) {
        window.location.href = '/logout';
      }
    }
  }, [loggedIn]);

  return (
    <>
      <Switch>
        <Route exact path="/" component={LoginPage} />
        <Route path={['/profile', '/alerts', '/users', '/account']} render={(props) => <PerformAdminRouter {...props} title={title} changeTitle={changeTitle} hide={false} />} />
        <Route exact path="/builders" component={PerformBuilders} />
        <Route exact path="/logout" component={UserLogout} />
        <Route exact path="/register/:id" component={SelfRegister} />
        <Route exact path="/register/:id/:tier" component={SelfRegister} />
        <Route exact path={'/home'} render={(props) => <PerformRouter {...props} title={title} changeTitle={changeTitle} hide={false} />} />
        <Route exact path={['/policy', '/policy/:type']} component={Policy} />
        <Route path={'/:base'} render={(props) => <PerformRouter {...props} title={title} changeTitle={changeTitle} hide={false} />} />
      </Switch>
    </>
  );
});

export default function App() {
  return (
    <AppThemeProvider>
      <Router>
        <AppWithRouter />
        <LoadAccountSettings />
      </Router>
    </AppThemeProvider>
  );
}
